import React, { useState } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import Button from 'src/components/Button';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import useSparkSyncTrigger from 'src/SharedCustomHooks/UseSparkSyncTrigger/useSparkSyncTrigger';
import './SparkSyncTriggerButton.scss';

const SparkSyncTriggerButton = () => {
  const { isSyncing, handleTriggerSync } = useSparkSyncTrigger();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleConfirmSync = () => {
    setIsConfirmModalOpen(false);
    handleTriggerSync();
  };

  return (
    <>
      <Button
        onClick={() => setIsConfirmModalOpen(true)}
        disabled={isSyncing}
        color="teal"
        size="small"
        icon={
          <span
            className={
              isSyncing
                ? 'spark-sync-trigger-icon spinning'
                : 'spark-sync-trigger-icon'
            }
          >
            <FontAwesomeIcon glyph="redo-alt" weight="solid" size="small" />
          </span>
        }
        label={isSyncing ? 'Syncing...' : 'Run Spark Sync'}
        style={{ marginRight: '1rem' }}
      />
      {isConfirmModalOpen && (
        <ConfirmationModal
          title="Run Spark Sync"
          message="Are you sure you want to manually trigger a Spark sync for all enabled properties? This is a one-way sync of data from Spark to Juniper, and any new data from Spark will be refreshed in Juniper. Where information differs between Spark and Juniper, Juniper data will be overwritten with Spark data."
          confirmLabel="Run Sync"
          cancelLabel="Cancel"
          variant="confirmation"
          requireTypeToConfirm={true}
          confirmationWord="SYNC"
          onConfirm={handleConfirmSync}
          onCancel={() => setIsConfirmModalOpen(false)}
          isSubmitting={isSyncing}
        />
      )}
    </>
  );
};

export default SparkSyncTriggerButton;
